<script setup lang="ts">
import { MarketingCards } from '~/lib/services/content/content.blocks.dtos'

defineProps<{
  block: MarketingCards
}>()
const isMobile = inject('isMobile')
</script>
<template>
  <SliderCustom
    :slides="block.marketingCards.length < 3 || isMobile ? 1 : 3"
    :loop="true"
    class="h-[320px] max-w-[360px] md:h-auto md:max-w-full"
  >
    <SwiperSlide v-for="mCard in block.marketingCards" :key="mCard.id">
      <SimpleLink :link="mCard">
        <img
          class="aspect-auto w-full"
          :src="isMobile ? mCard.imageMobile.url : mCard.imageDesktop.url"
          :alt="
            (isMobile ? mCard.imageMobile.alternativeText : mCard.imageDesktop.alternativeText) ||
            undefined
          "
          :title="
            (isMobile ? mCard.imageMobile.alternativeText : mCard.imageDesktop.alternativeText) ||
            'undefined'
          "
        />
      </SimpleLink>
    </SwiperSlide>
  </SliderCustom>
</template>
